module.exports = __webpack_public_path__ + "static/img/bg2.0abb14a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg2.jpg
// module id = GX8W
// module chunks = 19